import clsx from "clsx"
import * as React from "react"

export default function FeatureBar({ data }) {
  return (
    <div className="py-5 bg-white rounded-[45px] shadow-2xl">
      <div className="grid grid-cols-2 divide-x divide-zinc-700 text-secondary lg:grid-cols-4 gap-y-4">
        {data?.map((item, i) => {
          return (
            <div
              key={item.title}
              className={clsx(
                "px-4 xl:px-8 flex items-center gap-3.5 xl:gap-6 justify-center",
                i === 2 && "max-lg:!border-l-0"
              )}
            >
              <img
                src={item.icon.mediaItemUrl}
                alt="icon"
                className="w-6 sm:w-10"
              />
              <h4
                className="text-xs font-bold sm:text-base"
                dangerouslySetInnerHTML={{ __html: item.title }}
              ></h4>
            </div>
          )
        })}
      </div>
    </div>
  )
}
